import React from 'react';
import moment from 'moment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

export default function CustomDateTimePicker(props: {
    id: string,
    minDateTime?: any,
    maxDateTime?: any,
    value: any,
    field: string,
    index: number,
    handleInputChange: any,
    disabled: boolean,
}) {
    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DateTimePicker
                id={props.id}
                value={props.value}
                format='YYYY-MM-DD HH:mm'
                timeSteps={{ minutes: 30 }}
                minutesStep={30}
                minDate={props.minDateTime || null}
                maxDate={props.maxDateTime || null}
                disabled={props.disabled}
                onChange={(e) => {
                    const convertedDate = moment(e).format('YYYY-MM-DD HH:mm');
                    props.handleInputChange(
                        props.index,
                        props.field,
                        convertedDate
                    );
                }}
                slotProps={{
                    textField: {
                        fullWidth: true,
                        variant: 'standard',
                        error: false,
                    },
                }}
                closeOnSelect={false}
            />
        </LocalizationProvider>
    );
}
